<div>
  <div class="filter-container">
    <div class="row">
      <div class="col-2">
        <div class="filter-item-date" style="padding-left: 5%;">
          <div class="filter-item-label">{{'' | i18n: 'user-dealer'}}:</div>
          <select #select [(ngModel)]="filter.dealerNumber" (change)="refreshList()">
            <option value="null">{{'' | i18n: 'select'}}</option>
            @for (dealer of dealerName; track dealer) {
              <option value={{dealer.dealerNumber}}>{{dealer.dealerName}}</option>
            }
          </select>
        </div>
      </div>
      <div class="col-3 date-main pl-0 mr-0 pr-0">
        <div class="date-box">
          <div class="filter-item-date" style="padding-left: 0.1%;">
            <div class="filter-item-label">{{'' | i18n: 'period'}}:</div>
            <input id="toDates" [(ngModel)]="filter.fromDate" type="date" name="toDate" (change)="refreshList()">
          </div>
        </div>
        <div class="filter-to">
          <div class="filter-item-label" style="visibility: hidden;">..</div>
          {{'' | i18n: 'to'}}
        </div>
        <div class="date-box pl-0">
          <div class="filter-item-date" style="padding-left: 0.1%;">
            <div class="filter-item-label" style="visibility: hidden;">..</div>
            <input id="toDates1" [(ngModel)]="filter.toDate" type="date" name="toDate" (change)="refreshList()">
          </div>
        </div>
      </div>
      <div class="col-2 pl-0 mr-0 pr-0">
        <div class="filter-item-date" style="padding-left: 5%;">
          <div class="filter-item-label">{{'' | i18n: 'warranty-name'}}:</div>
          <select [(ngModel)]="filter.contractTypeId" (change)="refreshList()">
            <option value="null">{{'' | i18n: 'select'}}</option>
            @for (c of contractTypes; track c) {
              <option value="{{c.contractType}}">{{c.contractType}}</option>
            }
          </select>
        </div>
      </div>
      <div class="col-4 pl-0 ml-0">
        <div class="filter-item-date pl-0 ml-0">
          <div class="filter-item-label" style="visibility: hidden;">..</div>
          <button  class="button cross-btn ml-3" (click)="clearFilter()"> <i class="fa fa-times" aria-hidden="true"></i></button>

          <button id="refresh" (click)="refreshList()" class="button search-btnn ml-2">
            {{'' | i18n: 'search'}}
          </button>
          <button id="export" (click)="exportAsXLSX()" class="button search-btnn ml-2">
            {{'' | i18n: 'export'}}
          </button>
        </div>
      </div>
      <div class="col-1 pl-0 ml-0">
        <div class="page-container mr-0" >
          <button id="removePage" (click)="changePage(-1)" class="button button-page"
            [disabled]="this.filter.page == 0"><img alt="" src="assets/images/BMW-previous-144.png" width="20px"
          height="20px"></button>
          <div class="page-text-container"> {{ filter.page + 1 }} </div>
          <button id="addPage" (click)="changePage(1)" class="button button-page"  [disabled]="this.warrantyList.pageCount <= this.filter.page+1" >
            <img alt="" src="assets/images/BMW-next-144.png" width="20px" height="20px">
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="table-container">
    <table>
      <thead>
        <tr>
          <th>  <a (click)="orderBy('dealerNumber')">{{'' | i18n: 'dealer-number'}}@if (filter.orderBy == 'dealerNumber') {
            <img
              src="{{showDirectionImage()}}" alt="" class="sort-img"/>
          }</a></th>
          <th>  <a (click)="orderBy('dealerName')">{{'' | i18n: 'dealer-name'}}@if (filter.orderBy == 'dealerName') {
            <img
              src="{{showDirectionImage()}}" alt="" class="sort-img"/>
          }</a></th>
          <th><a (click)="orderBy('dateYear')">{{'' | i18n: 'year-registered'}}@if (filter.orderBy == 'dateYear') {
            <img
              src="{{showDirectionImage()}}" alt="" class="sort-img"/>
          }</a></th>
          <th><a (click)="orderBy('dateMonth')">{{'' | i18n: 'month-registered'}}@if (filter.orderBy == 'dateMonth') {
            <img
              src="{{showDirectionImage()}}" alt="" class="sort-img"/>
          }</a></th>
          <th> <a (click)="orderBy('contractType')">{{'' | i18n: 'warranty-name'}}@if (filter.orderBy == 'contractType') {
            <img
              src="{{showDirectionImage()}}" alt=""
              class="sort-img"/>
          }</a></th>
          <th><a (click)="orderBy('contractPeriod')">{{'' | i18n: 'contract-duration'}}@if (filter.orderBy == 'contractPeriod') {
            <img
              src="{{showDirectionImage()}}" alt=""
              class="sort-img"/>
          }</a></th>
          <th><a (click)="orderBy('contractCode')">{{'' | i18n: 'contract-code'}}@if (filter.orderBy == 'contractCode') {
            <img
              src="{{showDirectionImage()}}" alt="" class="sort-img"/>
          }</a></th>
          <th><a (click)="orderBy('contractCount')">{{'' | i18n: 'no-of-contracts'}}@if (filter.orderBy == 'contractCount') {
            <img
              src="{{showDirectionImage()}}" alt="" class="sort-img"/>
          }</a></th>
          <th><a (click)="orderBy('total')">{{'' | i18n: 'total-amount'}}@if (filter.orderBy == 'total') {
            <img
              src="{{showDirectionImage()}}" alt="" class="sort-img"/>
          }</a></th>

        </tr>
      </thead>
      <tbody>
        @for (dealer of warrantyList.dataList; track dealer) {
          <tr>
            <td>{{ dealer.dealerNumber }}</td>
            <td>{{ dealer.dealerName }}</td>
            <td>{{dealer.dateYear}}</td>
            <td>{{dealer.dateMonth}}</td>
            <td>{{dealer.contractType}}</td>
            <td>{{dealer.contractPeriod}}</td>
            <td>{{dealer.contractCode}}</td>
            <td>{{dealer.contractCount}}</td>
            <td>{{amount(dealer)}}</td>
          </tr>
        }
      </tbody>
    </table>
  </div>

</div>
